import axios from '@axios'
import { currency } from '@core/utils/filter'

export default {
  namespaced: true,
  state: {
    staticsAdmin: [],
    staticsTotalValorAdmin: [],
    staticsCliente: [],
    statusIcons: {
      total_clientes: {
        icon: 'UsersIcon',
        color: 'primary',
        title: 'Clientes',
        subtitle: 'Clientes',
        customClass: 'mb-2 mb-xl-0',
      },
      total_categorias: {
        icon: 'DollarSignIcon',
        color: 'danger',
        title: 'Categorias',
        subtitle: 'Categorias',
        customClass: 'mb-2 mb-sm-0',
      },
      total_itens: {
        icon: 'PackageIcon',
        color: 'warning',
        title: 'Itens',
        subtitle: 'Produto',
        customClass: 'mb-2 mb-xl-0',
      },
    },
    statusIconsCliente: {
      total_pedidos: {
        icon: 'UsersIcon',
        color: 'primary',
        title: 'Pedidos',
        subtitle: 'Pedidos',
        customClass: 'mb-2 mb-xl-0',
      },
      total_vendas_paga: {
        icon: 'DollarSignIcon',
        color: 'success',
        title: 'Total Pago',
        subtitle: 'Total Vendas',
        customClass: 'mb-2 mb-sm-0',
      },
      total_vendas_pendente: {
        icon: 'PackageIcon',
        color: 'warning',
        title: 'Itens',
        subtitle: 'Total Pendente',
        customClass: 'mb-2 mb-xl-0',
      },
      total_vendas_cancelada: {
        icon: 'PackageIcon',
        color: 'danger',
        title: 'Itens',
        subtitle: 'Total Cancelado',
        customClass: 'mb-2 mb-xl-0',
      },
    },
    statusIconsAdmin: {
      totaL_pedidos: {
        icon: 'UsersIcon',
        color: 'primary',
        title: 'Pedidos',
        subtitle: 'Pedidos',
        customClass: 'mb-2 mb-xl-0',
      },
      total_pedidos_pago: {
        icon: 'DollarSignIcon',
        color: 'success',
        title: 'Total Pago',
        subtitle: 'Total Vendas',
        customClass: 'mb-2 mb-sm-0',
      },
      total_pedidos_waiting_pendente: {
        icon: 'PackageIcon',
        color: 'warning',
        title: 'Itens',
        subtitle: 'Aguardando Pagamento',
        customClass: 'mb-2 mb-xl-0',
      },
      total_pedidos_cancelado: {
        icon: 'PackageIcon',
        color: 'danger',
        title: 'Itens',
        subtitle: 'Total Cancelado',
        customClass: 'mb-2 mb-xl-0',
      },
    },
  },
  getters: {
    GET_STATICS_ADMIN: state => state.staticsAdmin,
    GET_STATICS_CLIENTE: state => state.staticsCliente,
    GET_STATICS_ADMIN_TYPE_TWO: state => state.staticsTotalValorAdmin,
  },
  mutations: {
    SET_STATICS_ADMIN_TYPE_ONE(state, payload) {
      state.staticsAdmin = payload
    },
    SET_STATICS_ADMIN_TYPE_TWO(state, payload) {
      state.staticsTotalValorAdmin = payload
    },
    SET_STATICS_CLIENTE(state, payload) {
      state.staticsCliente = payload
    },
  },
  actions: {
    GET_STATICS_ADMIN_TYPE_ONE({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_STATICS_ADMIN_TYPE_ONE', [])
        axios
          .get('/dashboard/admin?type=1')
          .then(response => {
            const staticsAdmin = response.data
            Object.keys(staticsAdmin).forEach(key => {
              state.staticsAdmin.push({
                ...state.statusIcons[key],
                title: staticsAdmin[key],
              })
            })
            state.staticsAdmin.push({
              icon: 'DollarSignIcon',
              color: 'danger',
              title: 'R$ 0,000',
              subtitle: 'Vendas',
              customClass: 'mb-2 mb-sm-0',
            })
          })
          .catch(error => reject(error))
      })
    },
    GET_STATICS_ADMIN_TYPE_TWO({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_STATICS_ADMIN_TYPE_TWO', [])
        axios
          .get('/dashboard/admin?type=2')
          .then(response => {
            const staticsAdmin = response.data
            Object.keys(staticsAdmin).forEach(key => {
              const valuesCurrency = ['total_pedidos_pago', 'total_pedidos_waiting_pendente', 'total_pedidos_cancelado']
              if (valuesCurrency.includes(key)) {
                let val = `${staticsAdmin[key]}`.replaceAll(/[^0-9]/g, '')
                val /= 100
                if (val === 0) {
                  val = 'R$ 0,00'
                  staticsAdmin[key] = val
                } else {
                  staticsAdmin[key] = currency(val)
                }
              }
              state.staticsTotalValorAdmin.push({
                ...state.statusIconsAdmin[key],
                title: staticsAdmin[key],
              })
            })
          })
          .catch(error => reject(error))
      })
    },
    FETCH_STATICS_CLIENTE({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_STATICS_CLIENTE', [])
        axios
          .get('/dashboard/client')
          .then(response => {
            const staticsAdmin = response.data
            Object.keys(staticsAdmin).forEach(key => {
              const valuesCurrency = ['total_vendas_paga', 'total_vendas_pendente', 'total_vendas_cancelada']
              if (valuesCurrency.includes(key)) {
                let val = `${staticsAdmin[key]}`.replaceAll(/[^0-9]/g, '')
                val /= 100
                if (val === 0) {
                  val = 'R$ 0,00'
                  staticsAdmin[key] = val
                } else {
                  staticsAdmin[key] = currency(val)
                }
              }
              state.staticsCliente.push({
                ...state.statusIconsCliente[key],
                title: staticsAdmin[key],
              })
            })
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
  },
}
